module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "model-viewer"
    }
  }, [(_vm.selectCommodityOptions) ? _c('uiv-modal', {
    attrs: {
      "title": _vm.selectCommodityOptions.title,
      "backdrop": false
    },
    on: {
      "hide": _vm.selectCommodityDialogAccepted
    },
    model: {
      value: (_vm.showSelectCommodityDialog),
      callback: function($$v) {
        _vm.showSelectCommodityDialog = $$v
      },
      expression: "showSelectCommodityDialog"
    }
  }, [_c('select-commodity-dialog', {
    attrs: {
      "value": _vm.selectCommodityOptions
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editNodeDataModel) ? _c('uiv-modal', {
    attrs: {
      "footer": false,
      "title": "Edit " + _vm.editNodeDataModel.nodePathAndName + " Node Data",
      "backdrop": false,
      "size": "lg"
    },
    model: {
      value: (_vm.showEditNodeDataDialog),
      callback: function($$v) {
        _vm.showEditNodeDataDialog = $$v
      },
      expression: "showEditNodeDataDialog"
    }
  }, [_c('edit-node-data-dialog', {
    attrs: {
      "value": _vm.editNodeDataModel,
      "variableTreeDivId": "dialogVariableTree",
      "tableDivId": "dialogVariableTable"
    },
    on: {
      "closeClicked": _vm.showEditNodeDataDialogClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.createModelNodeModel) ? _c('uiv-modal', {
    attrs: {
      "footer": false,
      "title": "Create Model Node",
      "backdrop": false
    },
    model: {
      value: (_vm.showCreateModelNodeDialog),
      callback: function($$v) {
        _vm.showCreateModelNodeDialog = $$v
      },
      expression: "showCreateModelNodeDialog"
    }
  }, [_c('create-model-node-dialog', {
    attrs: {
      "value": _vm.createModelNodeModel
    },
    on: {
      "dialogAccepted": _vm.newModalNodeDialogAccepted,
      "dialogCanceled": _vm.newModalNodeDialogCanceled
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.linkDataModel) ? _c('uiv-modal', {
    attrs: {
      "footer": false,
      "title": _vm.linkDataModel.sourceNodePathAndName + " to " + _vm.linkDataModel.destNodePathAndName,
      "backdrop": false,
      "size": "lg"
    },
    model: {
      value: (_vm.showLinkDataDialog),
      callback: function($$v) {
        _vm.showLinkDataDialog = $$v
      },
      expression: "showLinkDataDialog"
    }
  }, [_c('link-data-dialog', {
    attrs: {
      "value": _vm.linkDataModel
    },
    on: {
      "dialogClosed": _vm.linkDataDialogClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.searchAndReplaceSettings) ? _c('uiv-modal', {
    attrs: {
      "title": "Search and Replace under " + _vm.searchAndReplaceSettings.rootNode,
      "backdrop": false,
      "footer": false
    },
    model: {
      value: (_vm.showSearchAndReplaceDialog),
      callback: function($$v) {
        _vm.showSearchAndReplaceDialog = $$v
      },
      expression: "showSearchAndReplaceDialog"
    }
  }, [_c('search-and-replace-dialog', {
    attrs: {
      "value": _vm.searchAndReplaceSettings
    },
    on: {
      "dialogClosed": _vm.searchAndReplaceDialogClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.exportNodeDataModel) ? _c('uiv-modal', {
    attrs: {
      "footer": false,
      "title": "Export data from " + _vm.exportNodeDataModel.nodePathAndName,
      "backdrop": false
    },
    model: {
      value: (_vm.showExportNodeDataDialog),
      callback: function($$v) {
        _vm.showExportNodeDataDialog = $$v
      },
      expression: "showExportNodeDataDialog"
    }
  }, [_c('export-node-data-dialog', {
    attrs: {
      "value": _vm.exportNodeDataModel
    },
    on: {
      "closeClicked": _vm.exportNodeDataDialogClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.uploadNodeDataInfo) ? _c('div', [_c('uiv-modal', {
    attrs: {
      "backdrop": false,
      "title": "Upload node data to " + _vm.uploadNodeDataInfo.modelId
    },
    model: {
      value: (_vm.showUploadNodeDataDialog),
      callback: function($$v) {
        _vm.showUploadNodeDataDialog = $$v
      },
      expression: "showUploadNodeDataDialog"
    }
  }, [_c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showUploadNodeDataDialog = false
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('upload-node-data-dialog', {
    on: {
      "tagsUploaded": _vm.onNodeDataUploaded,
      "tagsUploading": _vm.onNodeDataUploading
    },
    model: {
      value: (_vm.uploadNodeDataInfo),
      callback: function($$v) {
        _vm.uploadNodeDataInfo = $$v
      },
      expression: "uploadNodeDataInfo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.uploadAttachmentModel) ? _c('div', [_c('uiv-modal', {
    attrs: {
      "backdrop": false,
      "title": "Upload Attachment to " + _vm.uploadAttachmentModel.modelId
    },
    model: {
      value: (_vm.showUploadAttachmentDialog),
      callback: function($$v) {
        _vm.showUploadAttachmentDialog = $$v
      },
      expression: "showUploadAttachmentDialog"
    }
  }, [_c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showUploadAttachmentDialog = false
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('upload-attachment-dialog', {
    on: {
      "uploaded": _vm.onAttachmentUploaded,
      "uploading": _vm.onAttachmentUploading
    },
    model: {
      value: (_vm.uploadAttachmentModel),
      callback: function($$v) {
        _vm.uploadAttachmentModel = $$v
      },
      expression: "uploadAttachmentModel"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.exportNetworkDiagramConfig) ? _c('div', [_c('uiv-modal', {
    attrs: {
      "footer": false,
      "backdrop": false,
      "title": "Export " + _vm.exportNetworkDiagramConfig.rootSector + " Network Diagram"
    },
    model: {
      value: (_vm.showExportNetworkDiagramDialog),
      callback: function($$v) {
        _vm.showExportNetworkDiagramDialog = $$v
      },
      expression: "showExportNetworkDiagramDialog"
    }
  }, [_c('export-network-diagram-dialog', {
    on: {
      "dialogClosed": _vm.onExportNetworkDiagramDialogClosed
    },
    model: {
      value: (_vm.exportNetworkDiagramConfig),
      callback: function($$v) {
        _vm.exportNetworkDiagramConfig = $$v
      },
      expression: "exportNetworkDiagramConfig"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.distributeDiagramNodesOptions) ? _c('div', [_c('uiv-modal', {
    attrs: {
      "footer": false,
      "backdrop": false,
      "title": "Distribute Selected Node Icons"
    },
    model: {
      value: (_vm.showDistributeDiagramNodesDialog),
      callback: function($$v) {
        _vm.showDistributeDiagramNodesDialog = $$v
      },
      expression: "showDistributeDiagramNodesDialog"
    }
  }, [_c('distribute-diagram-nodes-dialog', {
    on: {
      "dialogClosed": _vm.onDistributeDiagramNodesDialogClosed
    },
    model: {
      value: (_vm.distributeDiagramNodesOptions),
      callback: function($$v) {
        _vm.distributeDiagramNodesOptions = $$v
      },
      expression: "distributeDiagramNodesOptions"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.diagramOptions) ? _c('div', [_c('uiv-modal', {
    attrs: {
      "footer": false,
      "backdrop": false,
      "title": "Network Diagram Options"
    },
    model: {
      value: (_vm.showDiagramOptionsDialog),
      callback: function($$v) {
        _vm.showDiagramOptionsDialog = $$v
      },
      expression: "showDiagramOptionsDialog"
    }
  }, [_c('network-diagram-options-dialog', {
    on: {
      "dialogClosed": _vm.onDiagramOptionsDialogClosed
    },
    model: {
      value: (_vm.diagramOptions),
      callback: function($$v) {
        _vm.diagramOptions = $$v
      },
      expression: "diagramOptions"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.reportCarouselConfig) ? _c('div', [_c('uiv-modal', {
    attrs: {
      "backdrop": false,
      "size": "lg",
      "header": false,
      "footer": false
    },
    model: {
      value: (_vm.showReportCarousel),
      callback: function($$v) {
        _vm.showReportCarousel = $$v
      },
      expression: "showReportCarousel"
    }
  }, [_c('report-carousel', {
    on: {
      "closeButtonClicked": function($event) {
        _vm.showReportCarousel = false
      }
    },
    model: {
      value: (_vm.reportCarouselConfig),
      callback: function($$v) {
        _vm.reportCarouselConfig = $$v
      },
      expression: "reportCarouselConfig"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [(_vm.downloadReportsModel) ? _c('uiv-modal', {
    attrs: {
      "footer": false,
      "title": "Download Reports",
      "backdrop": false,
      "size": "sm"
    },
    model: {
      value: (_vm.showDownloadReportsDialog),
      callback: function($$v) {
        _vm.showDownloadReportsDialog = $$v
      },
      expression: "showDownloadReportsDialog"
    }
  }, [_c('download-reports-dialog', {
    attrs: {
      "value": _vm.downloadReportsModel,
      "reportServices": _vm.reportServices,
      "modelServices": _vm.modelServices
    },
    on: {
      "dialogClosed": _vm.onDownloadReportsDialogClosed
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "buttonsDiv"
    }
  }, [_c('div', [(_vm.currentViewType) ? _c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "addSectorButton",
      "data-toggle": "tooltip",
      "title": "Add sector"
    },
    on: {
      "click": _vm.addSectorButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-folder"
  }), _vm._v("\n                    Add sector\n                ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "renameSectorButton",
      "data-toggle": "tooltip",
      "title": "Rename node in tree (F2)"
    },
    on: {
      "click": _vm.renameSectorButtonClick
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-edit"
  }), _vm._v("\n                    Rename\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "sectorPropertiesButton",
      "data-toggle": "tooltip",
      "title": "Edit node properties"
    },
    on: {
      "click": _vm.sectorPropertiesButtonClick
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list"
  }), _vm._v("\n                    Edit\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "deleteSectorButton",
      "data-toggle": "tooltip",
      "title": "Delete selected nodes in tree (Del)"
    },
    on: {
      "click": _vm.deleteNodeButtonClick
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-remove"
  }), _vm._v("\n                    Delete\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "searchAndReplaceButton",
      "data-toggle": "tooltip",
      "title": "Search and replace"
    },
    on: {
      "click": _vm.searchAndReplaceButtonClick
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-search"
  }), _vm._v("\n                    Replace\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "exportDataButton",
      "data-toggle": "tooltip",
      "title": "Export node data"
    },
    on: {
      "click": _vm.exportDataButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v("\n                    Export\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "importDataButton",
      "data-toggle": "tooltip",
      "title": "Import node data"
    },
    on: {
      "click": _vm.importDataButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-upload"
  }), _vm._v("\n                    Import\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu",
      "aria-labelledby": "dropdownMenu1"
    }
  }, [_c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": _vm.downloadSelectedViewsClick
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    }
  }, [_vm._v("Download checked views")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    },
    on: {
      "click": _vm.selectAllViews
    }
  }, [_vm._v("Select/deselect all")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": _vm.viewReportsCarouselButtonClick
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    }
  }, [_vm._v("View fullscreen")])]), _vm._v(" "), (false) ? _c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": _vm.publishToDashboard
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    }
  }, [_vm._v("Publish to dashboard...")])]) : _vm._e()])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled pull-right ",
    attrs: {
      "id": "treeForwardButton",
      "data-toggle": "tooltip",
      "title": "Forward"
    },
    on: {
      "click": _vm.treeForwardButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-forward"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled pull-right ",
    attrs: {
      "id": "treeBackButton",
      "data-toggle": "tooltip",
      "title": "Back"
    },
    on: {
      "click": _vm.treeBackButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-backward"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default toolbar-button disabled pull-right",
    attrs: {
      "id": "centerDiagramButton",
      "data-toggle": "tooltip",
      "title": "Center diagram"
    },
    on: {
      "click": _vm.centerDiagramClick
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-move"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled toolbar-button pull-right",
    attrs: {
      "id": "zoomInButton",
      "data-toggle": "tooltip",
      "title": "Zoom in diagram"
    },
    on: {
      "click": _vm.zoomInClick
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-zoom-in"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled toolbar-button pull-right",
    attrs: {
      "id": "zoomOutButton",
      "data-toggle": "tooltip",
      "title": "Zoom out diagram"
    },
    on: {
      "click": _vm.zoomOutClick
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-zoom-out"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled toolbar-button pull-right",
    attrs: {
      "id": "pasteButton",
      "data-toggle": "tooltip",
      "title": "Paste (ctrl-v)"
    },
    on: {
      "click": _vm.pasteButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-paste"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled toolbar-button pull-right",
    attrs: {
      "id": "copyButton",
      "data-toggle": "tooltip",
      "title": "Copy"
    },
    on: {
      "click": _vm.copyButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-copy"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled  pull-right",
    attrs: {
      "id": "goToNodeButton",
      "data-toggle": "tooltip",
      "title": "Go to node..."
    },
    on: {
      "click": _vm.goToNodeClick
    }
  }, [_c('span', {
    staticClass: "fa fa-location-arrow"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: (_vm.getRedoPeekHint()),
      expression: "getRedoPeekHint()",
      arg: "bottom"
    }],
    staticClass: "btn btn-default toolbar-button pull-right",
    attrs: {
      "id": "redo-button",
      "disabled": _vm.redoPeekCmd === null
    },
    on: {
      "click": _vm.redoClick
    }
  }, [_c('span', {
    staticClass: "fa fa-undo fa-flip-horizontal"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: (_vm.getUndoPeekHint()),
      expression: "getUndoPeekHint()",
      arg: "bottom"
    }],
    staticClass: "btn btn-default toolbar-button  pull-right",
    attrs: {
      "id": "undo-button",
      "disabled": _vm.undoPeekCmd === null
    },
    on: {
      "click": _vm.undoClick
    }
  }, [_c('span', {
    staticClass: "fa fa-undo"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "inline",
      "margin-bottom": "0",
      "vertical-align": "bottom",
      "max-width": "120px"
    },
    attrs: {
      "type": "search",
      "id": "treeFilterInputBox",
      "placeholder": "Search"
    },
    on: {
      "keyup": _vm.treeFilterInputBoxEditKeyUp
    }
  }), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    staticStyle: {
      "display": "inline",
      "margin-bottom": "0",
      "vertical-align": "bottom",
      "max-width": "100px"
    },
    attrs: {
      "id": "timepoint-edit",
      "placeholder": "Tree filter"
    }
  }), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    staticStyle: {
      "display": "inline",
      "margin-bottom": "0",
      "vertical-align": "bottom",
      "max-width": "100px"
    },
    attrs: {
      "id": "subtime-edit",
      "placeholder": "Tree filter"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-right": "0px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentViewType),
      expression: "currentViewType"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentViewType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeView(_vm.currentViewType)
      }]
    }
  }, _vm._l((_vm.viewTypes), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "id": "viewDiv"
    }
  }, [(_vm.showPublishToDashboardDialog) ? _c('div', {
    attrs: {
      "id": "exportRecordsTab"
    }
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "recordsExportsTab"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPublishToDashboardDialog),
      expression: "showPublishToDashboardDialog"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('publish-to-dashboard-dialog', {
    key: "dashboard-editor",
    attrs: {
      "value": _vm.publishToDashboardModel,
      "modelServices": _vm.modelServices,
      "reportServices": _vm.reportServices
    },
    on: {
      "dialogClosed": _vm.onDownloadReportsDialogClosed
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "dashboardDatasetsTab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('dashboard-datasets-dialog')], 1)])])])])])]) : _c('div', {
    staticClass: "nav-tabs-custom"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "id": "mainTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "diagramTab"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "diagramOptionsRow"
    }
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('vue-tags-input', {
    staticStyle: {
      "margin-left": "8px",
      "max-width": "unset"
    },
    attrs: {
      "placeholder": "Add tag",
      "autocomplete-items": _vm.nodeTagAutocompleteItems,
      "tags": _vm.tags
    },
    on: {
      "tags-changed": _vm.onNodeTagsChanged
    },
    model: {
      value: (_vm.tag),
      callback: function($$v) {
        _vm.tag = $$v
      },
      expression: "tag"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_vm._m(7), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu",
      "aria-labelledby": "dropdownMenu1"
    }
  }, [_c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.autoLayoutDiagram()
      }
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    }
  }, [_vm._v("Auto-layout")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.centerDiagramClick()
      }
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    }
  }, [_vm._v("Move to center")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.snapDiagramNodesToGrid()
      }
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    }
  }, [_vm._v("Snap nodes to grid")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.showDistributeDiagramNodesDialog = true
      }
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    }
  }, [_vm._v("Distribute selected icons...")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.resetKinkPoints()
      }
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    }
  }, [_vm._v("Reset kink points")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.onExportNetworkDiagramClick()
      }
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    }
  }, [_vm._v("Export Diagram...")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showDiagramOptionsDialog = true
      }
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    }
  }, [_vm._v("Options...")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_vm._m(8), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu",
      "aria-labelledby": "dropdownMenu1"
    }
  }, [_c('li', {
    attrs: {
      "role": "presentation",
      "disabled": _vm.getDiagramSelectionCount() === 0
    },
    on: {
      "click": _vm.createNodeTemplateFromDiagramClick
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    }
  }, [_vm._v("Create from diagram selection")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation",
      "disabled": _vm.getTreeSelectionCount() === 0
    },
    on: {
      "click": _vm.createNodeTemplateFromTreeClick
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1"
    }
  }, [_vm._v("Create from tree selection")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "dropdown-header"
  }, [_vm._v("Add from template:")]), _vm._v(" "), _vm._l((_vm.nodeTemplates), function(template) {
    return _c('li', [_c('a', {
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addNodeFromTemplate(template)
        }
      }
    }, [_vm._v(" - " + _vm._s(template.name) + " ")])])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "diagramDiv",
    staticStyle: {
      "position": "fixed",
      "height": "66%",
      "width": "62%"
    },
    attrs: {
      "id": "diagramDiv"
    }
  }, [_c('svg', {
    staticStyle: {
      "background-color": "white",
      "position": "absolute",
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "id": "diagramSVG"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "inputOutputDiagramTab"
    }
  }, [_c('div', {
    staticClass: "diagramDiv",
    staticStyle: {
      "position": "fixed",
      "height": "41%",
      "width": "61%"
    },
    attrs: {
      "id": "ioDiagramDiv"
    }
  }, [_c('svg', {
    staticStyle: {
      "background-color": "white",
      "position": "absolute",
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "id": "ioDiagramSVG"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "480px",
      "height": "25%",
      "width": "61%"
    },
    attrs: {
      "id": "ioChartsDiv"
    }
  }, [(_vm.nodeIoViewsCellObjects) ? _c('div', {
    attrs: {
      "id": "ioViewList"
    }
  }, [_c('grid-layout', {
    attrs: {
      "layout": _vm.nodeIoViewsCellObjects,
      "col-num": 3,
      "row-height": 150,
      "is-draggable": true,
      "is-resizable": true,
      "is-mirrored": false,
      "vertical-compact": false,
      "margin": [3, 3],
      "use-css-transforms": true
    },
    on: {
      "update:layout": function($event) {
        _vm.nodeIoViewsCellObjects = $event
      }
    }
  }, _vm._l((_vm.nodeIoViewsCellObjects), function(item) {
    return _c('grid-item', {
      key: item.id,
      attrs: {
        "x": item.x,
        "y": item.y,
        "w": item.w,
        "h": item.h,
        "i": item.i
      }
    }, [_c('div', {
      staticClass: "nodeView",
      attrs: {
        "id": item.id
      }
    }, [_c('div', {
      staticClass: "checkbox view-selector-checkbox-div"
    }, [_c('label', [_c('input', {
      staticClass: "viewSelectorCheckBox",
      attrs: {
        "type": "checkbox",
        "value": "selected",
        "data-viewid": item.viewName
      }
    }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(item.viewName) + " ")])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-xs expandViewButton",
      staticStyle: {
        "background-color": "transparent",
        "border-color": "transparent"
      },
      attrs: {
        "data-view-subjects": item.viewSubject
      },
      on: {
        "click": function($event) {
          return _vm.expandViewButtonClick(item.viewName, item.viewSubject)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-fullscreen"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "nodeView child-nodeView",
      attrs: {
        "id": "node-ui-view-div-" + item.id
      }
    })])])
  }), 1)], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "chartTab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.nodeChartsCellObjects) ? _c('div', [_c('div', {
    attrs: {
      "id": "nodeViewList"
    }
  }, [_c('grid-layout', {
    attrs: {
      "layout": _vm.nodeChartsCellObjects,
      "col-num": 3,
      "row-height": 150,
      "is-draggable": true,
      "is-resizable": true,
      "is-mirrored": false,
      "vertical-compact": false,
      "margin": [3, 3],
      "use-css-transforms": true
    },
    on: {
      "update:layout": function($event) {
        _vm.nodeChartsCellObjects = $event
      }
    }
  }, _vm._l((_vm.nodeChartsCellObjects), function(item) {
    return _c('grid-item', {
      key: item.id,
      attrs: {
        "x": item.x,
        "y": item.y,
        "w": item.w,
        "h": item.h,
        "i": item.i
      }
    }, [_c('div', {
      staticClass: "nodeView",
      attrs: {
        "id": item.id
      }
    }, [_c('div', {
      staticClass: "checkbox view-selector-checkbox-div"
    }, [_c('label', [_c('input', {
      staticClass: "viewSelectorCheckBox",
      attrs: {
        "type": "checkbox",
        "value": "selected",
        "data-viewid": item.viewName
      }
    }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(item.viewName) + " ")])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-xs expandViewButton",
      staticStyle: {
        "background-color": "transparent",
        "border-color": "transparent"
      },
      attrs: {
        "data-view-subjects": item.viewSubject
      },
      on: {
        "click": function($event) {
          return _vm.expandViewButtonClick(item.viewName, item.viewSubject)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-fullscreen"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "nodeView child-nodeView",
      attrs: {
        "id": "chart-div-" + item.id
      }
    })])])
  }), 1)], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tablesTab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [(_vm.nodeTablesCellObjects) ? _c('div', [_c('div', {
    attrs: {
      "id": "#nodeTablesViewList"
    }
  }, [_c('grid-layout', {
    attrs: {
      "layout": _vm.nodeTablesCellObjects,
      "col-num": 3,
      "row-height": 100,
      "is-draggable": true,
      "is-resizable": true,
      "is-mirrored": false,
      "vertical-compact": false,
      "margin": [3, 3],
      "use-css-transforms": true
    },
    on: {
      "update:layout": function($event) {
        _vm.nodeTablesCellObjects = $event
      }
    }
  }, _vm._l((_vm.nodeTablesCellObjects), function(item) {
    return _c('grid-item', {
      key: item.id,
      attrs: {
        "x": item.x,
        "y": item.y,
        "w": item.w,
        "h": item.h,
        "i": item.i
      }
    }, [_c('div', {
      staticClass: "nodeView",
      attrs: {
        "id": item.id
      }
    }, [_c('div', {
      staticClass: "checkbox view-selector-checkbox-div"
    }, [_c('label', [_c('input', {
      staticClass: "viewSelectorCheckBox",
      attrs: {
        "type": "checkbox",
        "value": "selected",
        "data-viewid": item.viewName
      }
    }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(item.viewName) + " ")])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-xs expandViewButton",
      staticStyle: {
        "background-color": "transparent",
        "border-color": "transparent"
      },
      attrs: {
        "data-view-subjects": item.viewSubject
      },
      on: {
        "click": function($event) {
          return _vm.expandViewButtonClick(item.viewName, item.viewSubject)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-fullscreen"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "nodeView child-nodeView",
      attrs: {
        "id": "table-div-" + item.id
      }
    })])])
  }), 1)], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "mapsTab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [(_vm.nodeMapsCellObjects) ? _c('div', [_c('div', {
    attrs: {
      "id": "#nodeMapsViewList"
    }
  }, [_c('grid-layout', {
    attrs: {
      "layout": _vm.nodeMapsCellObjects,
      "col-num": 3,
      "row-height": 200,
      "is-draggable": true,
      "is-resizable": true,
      "is-mirrored": false,
      "vertical-compact": false,
      "margin": [3, 3],
      "use-css-transforms": true
    },
    on: {
      "update:layout": function($event) {
        _vm.nodeMapsCellObjects = $event
      }
    }
  }, _vm._l((_vm.nodeMapsCellObjects), function(item) {
    return _c('grid-item', {
      key: item.id,
      attrs: {
        "x": item.x,
        "y": item.y,
        "w": item.w,
        "h": item.h,
        "i": item.i
      }
    }, [_c('div', {
      staticClass: "nodeView",
      attrs: {
        "id": item.id
      }
    }, [_c('div', {
      staticClass: "checkbox view-selector-checkbox-div"
    }, [_c('label', [_c('input', {
      staticClass: "viewSelectorCheckBox",
      attrs: {
        "type": "checkbox",
        "value": "selected",
        "data-viewid": item.viewName
      }
    }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(item.viewName) + " ")])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-xs expandViewButton",
      staticStyle: {
        "background-color": "transparent",
        "border-color": "transparent"
      },
      attrs: {
        "data-view-subjects": item.viewSubject
      },
      on: {
        "click": function($event) {
          return _vm.expandViewButtonClick(item.viewName, item.viewSubject)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-fullscreen"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "nodeView child-nodeView",
      attrs: {
        "id": "table-div-" + item.id
      }
    })])])
  }), 1)], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "attachmentsTab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "uploadAttachmentButton",
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Upload file"
    },
    on: {
      "click": _vm.uploadAttachment
    }
  }, [_vm._v("\n                                    Upload File\n                                    "), _c('span', {
    staticClass: "glyphicon glyphicon-upload"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "refreshAttachmentsButton",
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Refresh"
    },
    on: {
      "click": _vm.doRefreshAttachments
    }
  }, [_vm._v("\n                                    Refresh List\n                                    "), _c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning pull-right",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Delete All"
    },
    on: {
      "click": _vm.doDeleteAllAttachments
    }
  }, [_vm._v("\n                                    Delete all attachments\n                                    "), _c('span', {
    staticClass: "glyphicon glyphicon-remove"
  })])])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "nodeVariablesTab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    attrs: {
      "id": "nodeVariablesContainer"
    }
  }, [_vm._m(10), _vm._v(" "), (_vm.editNodeDataModel) ? _c('edit-node-data-dialog', {
    attrs: {
      "value": _vm.editNodeDataModel,
      "variableTreeDivId": "embeddedVariableTree",
      "tableDivId": "embeddedVariableTable"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "commentsTab"
    }
  }, [_c('model-annotations-table', {
    attrs: {
      "value": _vm.modelId,
      "nodePathAndName": _vm.commentsNodePathAndName
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "nodeSpreadsheetTab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "saveNodeSpreadsheetChangesButton",
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Save changes"
    },
    on: {
      "click": _vm.saveNodeSpreadsheetChangesButtonClick
    }
  }, [_vm._v("\n                                    Save\n                                    "), _c('span', {
    staticClass: "glyphicon glyphicon-save"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "cancelNodeSpreadsheetChangesButton",
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Cancel changes"
    },
    on: {
      "click": _vm.refreshSpreadsheet
    }
  }, [_vm._v("\n                                    Cancel\n                                    "), _c('span', {
    staticClass: "glyphicon glyphicon-remove"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "refreshNodeSpreadsheetButton",
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Refresh"
    },
    on: {
      "click": _vm.refreshSpreadsheet
    }
  }, [_vm._v("\n                                    Refresh\n                                    "), _c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  })])])]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "raw-node-editor-tab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('raw-node-editor', {
    attrs: {
      "value": _vm.modelId,
      "nodePathAndName": _vm.rawNodeEditorNodePathAndName
    }
  })], 1)])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "linkDataModalDiv",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "linkDataDialogHeaderLabel",
      "aria-hidden": "true",
      "data-url": "@Url.Action(\"ShowLinkDataView\")"
    }
  }, [_c('div', {
    attrs: {
      "id": "linkDataModalContainer"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "exportResultsModalDiv",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exportResultsModalLabel",
      "aria-hidden": "true",
      "data-url": "@Url.Action(\"ShowExportResultsView\")"
    }
  }, [_c('div', {
    attrs: {
      "id": "exportResultsModalDivContainer"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "reportCarouselModalDiv",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true",
      "data-url": "@Url.Action(\"ReportCarouselPartial\", \"Reports\")"
    }
  }, [_c('div', {
    attrs: {
      "id": "reportCarouselModalDivContainer"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "id": "charts-dropdown",
      "data-toggle": "dropdown",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                            Charts "), _c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "height": "73%",
      "width": "20%"
    },
    attrs: {
      "id": "treeDiv"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "viewTabLi active"
  }, [_c('a', {
    attrs: {
      "href": "#recordsExportsTab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Exports")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi"
  }, [_c('a', {
    attrs: {
      "href": "#dashboardDatasetsTab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Datasets")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "navTabs"
    }
  }, [_c('li', {
    staticClass: "viewTabLi active",
    attrs: {
      "id": "diagramTabLi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#diagramTab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Diagram")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi",
    attrs: {
      "id": "inputOutputDiagramTabLi",
      "data-view-parent-id": "#ioViewList"
    }
  }, [_c('a', {
    attrs: {
      "href": "#inputOutputDiagramTab",
      "data-toggle": "tab"
    }
  }, [_vm._v("I/O Diagram")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi",
    attrs: {
      "id": "chartTabLi",
      "data-view-parent-id": "#nodeViewList"
    }
  }, [_c('a', {
    attrs: {
      "href": "#chartTab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Charts ")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi",
    attrs: {
      "id": "tablesTabLi",
      "data-view-parent-id": "#nodeTablesViewList"
    }
  }, [_c('a', {
    attrs: {
      "href": "#tablesTab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Tables ")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi",
    attrs: {
      "id": "mapsTabLi",
      "data-view-parent-id": "#mapsViewList"
    }
  }, [_c('a', {
    attrs: {
      "href": "#mapsTab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Maps ")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi",
    attrs: {
      "id": "attachmentsTabLi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#attachmentsTab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Files")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi",
    attrs: {
      "id": "nodeSpreadsheetTabLi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#nodeSpreadsheetTab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Spreadsheet")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi",
    attrs: {
      "id": "nodeVariablesTabLi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#nodeVariablesTab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Properties")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi",
    attrs: {
      "id": "commentsTabLi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#commentsTab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Comments")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi",
    attrs: {
      "id": "nodeHistoryTabLi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#nodeHistoryTab",
      "data-toggle": "tab"
    }
  }, [_vm._v("History")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi",
    attrs: {
      "id": "raw-node-editor-tab-li"
    }
  }, [_c('a', {
    attrs: {
      "href": "#raw-node-editor-tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Raw")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                                                Diagram "), _c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                                                    Node Templates "), _c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-condensed",
    attrs: {
      "id": "attachmentsTable",
      "width": "100%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "nodeDataEditorResponseDiv"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "nodeHistoryTab"
    }
  }, [_c('div', [_c('table', {
    staticClass: "table table-striped table-condensed",
    attrs: {
      "id": "historyTable",
      "width": "100%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "470px",
      "overflow": "auto"
    },
    attrs: {
      "id": "nodeSpreadsheetContainer"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6ebf49fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ebf49fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/model-viewer/model-viewer.vue.html
// module id = 1114
// module chunks = 0